module.exports = __webpack_public_path__ + "static/media/add-card-american-exp.28e67169.svg";